import { Box, styled } from '@mui/material';

const ErrorsBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  width: max-content;
`;

export default ErrorsBox;
